
export const SET_CANARY_CONFIG = "SET_CANARY_CONFIG"

export const setCanaryFeatures = config => {
    return { type: SET_CANARY_CONFIG, data: config}
}


// WEBPACK FOOTER //
// ./modules/Common/actions/canary.js